import { HoverFill } from '@tencent/one-design-next';
import classNames from 'classnames';
import React from 'react';

import './index.scss';

type MenuListItem = Record<string, any>;

type DefaultMenuListData = {
  id: string | number | undefined;
  label: string;
  desc?: string;
  supplement?: string | React.ReactNode;
}

export interface IMenuList<T extends MenuListItem = DefaultMenuListData> {
  className?: string;
  style?: React.CSSProperties;
  data: T[];
  value: string | number | undefined;
  keyField?: keyof T;
  labelField?: keyof T;
  descField?: keyof T;
  supplementField?: keyof T;
  useHoverFill?: boolean;
  onChange?: (id: string | number | undefined) => void;
}

const MenuList = <T extends MenuListItem = DefaultMenuListData>(props: IMenuList<T>) => {
  const {
    className,
    style,
    data,
    value,
    onChange,
    keyField = 'id' as keyof T,
    labelField = 'label' as keyof T,
    descField = 'desc' as keyof T,
    supplementField = 'supplement' as keyof T,
    useHoverFill = true,
  } = props;

  return (
    <div className={classNames('odc-menu-list', className)} style={style}>
      {data.map(item => (
        <HoverFill
          key={`od_menu_list_${item[keyField]}`}
          bgClassName="rounded-md"
          hoverColor="rgba(10, 10, 10, 0.03)"
          activeColor="rgba(10, 10, 10, 0.05)"
          disabled={!useHoverFill}
        >
          <div
            className={classNames('menu-list-item', { active: item[keyField] === value })}
            data-key={item[keyField]}
            onClick={(e) => {
              e.stopPropagation();
              onChange?.(item[keyField]);
            }}
          >
            <div className="flex-1 min-w-0">
              <p className="menu-list-label">{item[labelField]}</p>
              {item[descField] && <p className="menu-list-desc">{item[descField]}</p>}
            </div>
            {item[supplementField] && <span className="menu-list-supplement">{item[supplementField]}</span>}
          </div>
        </HoverFill>
      ))}
    </div>
  );
};

export default MenuList;